import type { ApiTableAutocompleteHook } from 'components/FormikTypeaheadInput/useApiTableAutocomplete';
import { usePathLookupIpAutocomplete } from 'components/Graph/GraphSidePanel/GraphPathlookup/usePathLookupIpAutocomplete';
import type { GraphPathLookupIpOption } from './GraphPathLookupIpOption';

interface Props {
  excludeIps?: string[];
  type: 'source' | 'group' | 'receiver';
}

export const usePathLookupIpAutocompleteMulticast = (
  props: Props,
): ApiTableAutocompleteHook<GraphPathLookupIpOption> =>
  usePathLookupIpAutocomplete({
    ...props,
    url: '/tables/addressing/path-lookup-sources-multicast',
    additionalFilters: [{ type: ['eq', props.type] }],
  });
